import React from 'react';
import { Button, Input, styled, css } from '@goodrx/matisse';

import { useAppContext } from 'app/config/AppContext';
import { mediaMinWidth } from 'app/lib/utils';

const InputWrapper = styled.div`
  position: relative;
  border-top: 1px solid ${(p) => p.theme.colors.greyLight};
`;

const StyledInput = styled(Input)(
  (p) => css`
    resize: none;
    min-height: ${p.appTheme.components.chat?.minHeight || '100px'};
    height: 100%;
    border-radius: 0;
    border: none;
    padding: ${p.theme.space[3]}px 114px ${p.theme.space[3]}px ${p.theme.space[3]}px;
    color: ${p.theme.components.chat?.placeholderTextFontColor || '#1B202B'};
    font-weight: ${p.appTheme.components.chat?.placeholderFontWeight || '500'};
    font-family: ${p.appTheme.typography?.baseFontFamily};

    ${mediaMinWidth({
      md: css`
        padding: ${p.theme.space[4]}px 130px ${p.theme.space[4]}px ${p.theme.space[5]}px;
      `,
    })}
  `
);

const ButtonWrapper = styled(Button)(
  (p) => css`
    position: absolute;
    bottom: ${p.theme.components.chat?.sendButtonBottom || '24px'};
    right: ${p.theme.space[3]}px;
    width: 90px;
    padding: 0 8px;
    font-family: ${p.appTheme.typography?.baseFontFamily};

    ${mediaMinWidth({
      md: css`
        right: ${p.theme.space[5]}px;
      `,
    })}
  `
);

interface ChatInputProps {
  onSubmit: any;
  message: any;
  sendingMessage: any;
  onChange: any;
}

const ChatInput = ({ onSubmit, message, sendingMessage, onChange }: ChatInputProps) => {
  const {
    config: { Theme: appTheme },
  } = useAppContext();

  return (
    <InputWrapper>
      <StyledInput
        id="message"
        autofocus
        multiline
        name="message"
        value={message}
        placeholder="Type your message here.."
        onChange={onChange}
        appTheme={appTheme}
      />

      <ButtonWrapper
        appTheme={appTheme}
        type="primary"
        onClick={onSubmit}
        disabled={!message || !message.trim() || sendingMessage}>
        Send
      </ButtonWrapper>
    </InputWrapper>
  );
};

export default ChatInput;
